export class BalanceSheet {
  AccountName: string = null;
  AccountNumber: number = null;
  AltTotalFlag = 0;
  Category: string = null;
  DisplayOrder: number = null;
  FilterCriteria: string = null;
  Mnemonic: string = null;
  ParentAcctNum: number = null;

  toString(): string {
    return JSON.stringify(this);
  }
}

export interface BalanceSheetDB {
  account_name: any;
  account_number: number;
  alt_total_flag: number;
  category: string;
  display_order: number;
  filter_criteria: string;
  mnemonic: string;
  parent_account_number: number;
  date_time_created: string;
}
